import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Store, Ticket, Newspaper, Menu } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const ITEMS = [
  { key: "inicio", label: "Início", icon: Home, to: "/", sectionKey: null },
  { key: "empresas", label: "Empresas", icon: Store, to: "/empresas", sectionKey: "all_businesses" },
  { key: "cupons", label: "Cupons", icon: Ticket, to: "/#coupons", sectionKey: "coupons" },
  { key: "noticias", label: "Notícias", icon: Newspaper, to: "/#news", sectionKey: "news" },
  { key: "mais", label: "Mais", icon: Menu, to: "/#footer", sectionKey: null },
];

const BottomNav = () => {
  const { settings, isEnabled } = useSite();
  const location = useLocation();
  const navigate = useNavigate();
  const enabledKeys = settings?.bottom_nav || ["inicio", "empresas", "cupons", "noticias", "mais"];

  const items = ITEMS.filter(
    (i) => enabledKeys.includes(i.key) && (!i.sectionKey || isEnabled(i.sectionKey))
  );

  const handle = (e, to) => {
    if (to.includes("#")) {
      e.preventDefault();
      const [path, hash] = to.split("#");
      if (location.pathname !== (path || "/")) {
        navigate(to);
      } else {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-card border-t border-border shadow-[0_-4px_12px_-4px_rgba(0,0,0,0.08)]"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around h-16">
        {items.map((i) => {
          const Icon = i.icon;
          const active = location.pathname === i.to;
          return (
            <Link
              key={i.key}
              to={i.to}
              onClick={(e) => handle(e, i.to)}
              data-testid={`bottomnav-${i.key}`}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors ${
                active ? "text-primary" : "text-muted-foreground"
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-semibold">{i.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
